export const BACKEND_URL = "https://marg-darshak.onrender.com"